export enum PeopleTypeEnum {
  PESSOA_FISICA = 'pf',
  PESSOA_JURIDICA = 'pj',
}

export enum PeopleTypeIdEnum {
  'PESSOA_FISICA' = 1,
  'PESSOA_JURIDICA' = 2,
}

export function getPeopleTypeDescriptionByValue(value: string) {
  const indexOfS = Object.values(PeopleTypeIdEnum).indexOf(
    value as unknown as PeopleTypeIdEnum
  );

  const key = Object.keys(PeopleTypeIdEnum)[indexOfS];

  return key;
}
